import dynamic from "next/dynamic";

const Templates = {
  gallery: dynamic(() => import("../../RenderBody/components/RelatedNewsBody")),
  freehtml: dynamic(() => import("../../RenderBodyVintage/components/FreeHtml")),
  embed: dynamic(() => import("../../RenderBodyVintage/components/FreeHtml")),
  image: dynamic(() => import("../../RenderBodyVintage/components/ImageBody")),
  blockquote: dynamic(() => import("../../RenderBody/components/Blockquote")),
  lilanews: dynamic(() => import("../../RenderBody/components/RelatedNewsBody")),
  text: dynamic(() => import("../../RenderBodyVintage/components/TextBody")),
  video: dynamic(() => import("../../RenderBodyVintage/components/Video")),
  textHtml: dynamic(() => import("../../RenderBodyVintage/components/TextHtml")),
};

export default Templates;
